import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from '@nolimitcity/slot-game/bin/core/event/EventHandler';
import {GameEvent} from '@nolimitcity/slot-game/bin/core/event/GameEvent';
import {ReelEvent} from '@nolimitcity/slot-game/bin/core/reel/event/ReelEvent';
import {Reels} from '@nolimitcity/slot-game/bin/core/reel/reelarea/Reels';
import {GameResources} from '@nolimitcity/slot-game/bin/core/resource/GameResources';
import {SpinEvent} from '@nolimitcity/slot-game/bin/core/spin/event/SpinEvent';
import {ScalableLayer} from '@nolimitcity/slot-game/bin/core/stage/ScalableLayer';
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from '@nolimitcity/slot-launcher/bin/animation/TimelineSprite';
import {BarbarianFuryGameConfig} from '../BarbarianFuryGameConfig';

export class ForegroundAnimation extends BaseView {
    private _layer:ScalableLayer;
    private _animItems:TimelineSprite[][] = [];
    private _anticipationAnimItems:TimelineSprite;
    private _teaseAnimationContainer:TimelineSprite[] = [];
    private _postteaseAnimationContainer:TimelineSprite[][] = [];
    private _reSpinAnimationContainer:TimelineSprite[] = [];
    private _respinAnticipationPlayingOnReels:number[] = [];

    constructor() {
        super();
        this._layer = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.FOREGROUND.name);
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => this.hideSymbolAnimation());
        EventHandler.addEventListener(this, "reelTeaseStart", (event:GameEvent) => this.playTeaseAnimation(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, "teaseAborted", () => this.hideAllteaseAnimation());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, () => this.hideAllrespinAnimation()); // blind fix for #244
    }

    /**
     * override this function to create symbol animation when asset is loaded
     */
    protected initAnimations():void {
        super.initAnimations && super.initAnimations();
        this.createSymbolAnimation();
        this.createAnticipationAnimation();
        this.creaTeaseAnimation();
        this.createReSpinAnticipation();
        this.createpostTeaseAnimation();

    }

    /**
     * create win symbol animaition as per grid.
     */
    private createSymbolAnimation() {
        for(let i = 0; i < 6; i++) {
            this._animItems[i] = [];
            for(let j = 0; j < 5; j++) {
                let symbol_anim:TimelineSprite = new TimelineSprite(GameResources.getTextures("BetLineBoxAnimation"), 20);
                symbol_anim.scale.set(2);
                symbol_anim.anchor.set(0.5);
                symbol_anim.blendMode = PIXI.BLEND_MODES.ADD;
                this._animItems[i].push(symbol_anim);
                symbol_anim.visible = false;
                this._layer.addChild(symbol_anim);
            }
        }
    }

    /**
     * function to play symbol win animation
     * @param reelId
     * @param symId
     */
    public playSymbolWinAnimation(reelId:number, symId:number) {
        this.changeSymStateOfFireSymbol(reelId, symId);
        this._animItems[reelId][symId].position.set(Helper.getSymbolPositions(reelId, symId)[0], Helper.getSymbolPositions(reelId, symId)[1]);
        this._layer.addChild(this._animItems[reelId][symId]);
        const winAnim = this._animItems[reelId][symId].getAnimationAutoShowHide(true, true);
        return winAnim;
    }

    /**
     * function to hide all symbol animations for 5X4 grid
     */
    public hideSymbolAnimation():void {
        for(let i = 0; i < 6; i++) {
            for(let j = 0; j < 5; j++) {
                this._animItems[i][j].visible = false;
                this._animItems[i][j].stopLoop();
                this._layer.removeChild(this._animItems[i][j]);
            }
        }
    }

    /**
     * function to change symbol state on which fire will be played
     * @param reelId
     * @param symId
     */
    private changeSymStateOfFireSymbol(reelId:number, symId:number):void {
        const noWinSymbol = Reels.getSymbol(reelId, symId);
        if(noWinSymbol) {
            noWinSymbol.changeState({
                state : BarbarianFuryGameConfig.instance.SYMBOL_STATES.win,
                setStack : true,
                fadeInDuration : 0
            });
        }
    }

    /**
     * fuction to create scatter anticipation animation
     */
    private createAnticipationAnimation():void {
        let symbol_anim:TimelineSprite = new TimelineSprite(GameResources.getTextures("anticipationAnim"), 20);
        symbol_anim.scale.set(2);
        symbol_anim.blendMode = PIXI.BLEND_MODES.ADD;
        symbol_anim.anchor.set(0.5);
        this._anticipationAnimItems = symbol_anim;
        symbol_anim.visible = false;
        this._layer.addChild(symbol_anim);
    }

    /**
     * function to play scatter anticipation animation base on reel ID
     * @param reelId
     */
    public playAnticipationAnimation(reelId:number):void {
        this.hideAllAnticipationAnim();
        if(reelId > BarbarianFuryGameConfig.instance.SYMBOLS_NUM_IN_REEL[2]) { // added to fix #270
            return;
        }
        this._anticipationAnimItems.visible = true;
        this._anticipationAnimItems.playLoop();
        this._anticipationAnimItems.position.set(Helper.getSymbolPositions(reelId, 0)[0], BarbarianFuryGameConfig.instance.REEL_AREA_POS_Y + BarbarianFuryGameConfig.instance.SYMBOL_HEIGHT * 2);
        this._layer.addChild(this._anticipationAnimItems);
    }

    /**
     * function to hide all scatter anticipation animation
     */
    public hideAllAnticipationAnim() {
        this._anticipationAnimItems.visible = false;
        this._anticipationAnimItems.stopLoop();
        this._layer.removeChild(this._anticipationAnimItems);
    }

    /**
     * function to create tease animation
     */
    private creaTeaseAnimation():void {
        for(let i = 0; i < 5; i++) {
            let teaseAnim:TimelineSprite = new TimelineSprite(GameResources.getTextures("TeaseAnimation"), 22);
            teaseAnim.anchor.set(0.5);
            teaseAnim.blendMode = PIXI.BLEND_MODES.ADD;
            teaseAnim.visible = true;
            this._teaseAnimationContainer.push(teaseAnim);
            this._teaseAnimationContainer[i].position.set(Helper.getSymbolPositions(i, 1)[0], Helper.getSymbolPositions(i, 1)[1]);
        }
    }

    /**
     * function to play tease animation based on reelId and direction of nudging
     * @param reelId
     * @param NudgeUp
     */
    public playTeaseAnimation(reelId:number, NudgeUp:boolean = true):void {
        let angleAnim:number = NudgeUp ? 180 : 0;
        let y:number = NudgeUp ? Helper.getSymbolPositions(reelId, 1)[1] + BarbarianFuryGameConfig.instance.SYMBOL_HEIGHT : Helper.getSymbolPositions(reelId, 1)[1];
        this._teaseAnimationContainer[reelId].y = y;
        this._teaseAnimationContainer[reelId].angle = angleAnim;
        this._teaseAnimationContainer[reelId].visible = true;
        this._teaseAnimationContainer[reelId].playLoop();
        this._layer.addChild(this._teaseAnimationContainer[reelId]);
    }

    /**
     * function to hide all tease aimations on tease completed or tease abort
     */
    public hideAllteaseAnimation():void {
        for(let i = 0; i < this._teaseAnimationContainer.length; i++) {
            this._teaseAnimationContainer[i].visible = false;
            this._teaseAnimationContainer[i].stopLoop();
            this._layer.removeChild(this._teaseAnimationContainer[i]);

        }
    }

    /**
     * functio to create re-spi anticpatio animatio this funciton will be called from init.
     */
    private createReSpinAnticipation():void {
        for(let i = 0; i < 6; i++) {
            let respinAnim:TimelineSprite = new TimelineSprite(GameResources.getTextures("Re_spin_Anticipation"), 35);
            respinAnim.blendMode = PIXI.BLEND_MODES.ADD;
            respinAnim.scale.set(2);
            respinAnim.height = respinAnim.height - 80;
            respinAnim.anchor.set(0.5);
            this._reSpinAnimationContainer.push(respinAnim);
            if(i < 5) {
                this._reSpinAnimationContainer[i].position.set(Helper.getSymbolPositions(i, 1)[0] - 35, BarbarianFuryGameConfig.instance.REEL_AREA_POS_Y + BarbarianFuryGameConfig.instance.SYMBOL_HEIGHT * 2);
            } else {
                this._reSpinAnimationContainer[i].position.set((Helper.getSymbolPositions(4, 1)[0] - 40) + BarbarianFuryGameConfig.instance.SYMBOL_WIDTH, BarbarianFuryGameConfig.instance.REEL_AREA_POS_Y + BarbarianFuryGameConfig.instance.SYMBOL_HEIGHT * 2);
            }
        }
    }

    /**
     * create post tease animation here of 2d array
     * with each index of 2 post tease animation like aniticpation.
     */
    private createpostTeaseAnimation():void {
        for(let i = 0; i < 5; i++) {
            this._postteaseAnimationContainer[i] = [];
            for(let j = 0; j < 2; j++) {
                let postTeaseAnim:TimelineSprite = new TimelineSprite(GameResources.getTextures("postTeaseAnimation"), 35);
                postTeaseAnim.blendMode = PIXI.BLEND_MODES.ADD;
                postTeaseAnim.anchor.set(0.5);
                this._postteaseAnimationContainer[i].push(postTeaseAnim);
                this._postteaseAnimationContainer[i][j].position.set(Helper.getSymbolPositions(i, 1)[0] + (BarbarianFuryGameConfig.instance.SYMBOL_WIDTH * j) - 70, Helper.getSymbolPositions(i, 1)[1]);
            }
        }

    }

    /**
     * function to play respin fire animaiton for each reel id we are palying 2 bars animation.
     * @param allreelIds
     */
    public playRespinAnticipation(allreelIds:number[]):void {
        this.hideAllrespinAnimation();
        this._respinAnticipationPlayingOnReels = allreelIds;
        for(let reelId = 0; reelId < allreelIds.length; reelId++) {
            this._reSpinAnimationContainer[allreelIds[reelId]].visible = true;
            this._reSpinAnimationContainer[allreelIds[reelId]].playLoop();
            this._layer.addChild(this._reSpinAnimationContainer[allreelIds[reelId]]);
            this._reSpinAnimationContainer[allreelIds[reelId] + 1].visible = true;
            this._reSpinAnimationContainer[allreelIds[reelId] + 1].playLoop();
            this._layer.addChild(this._reSpinAnimationContainer[allreelIds[reelId] + 1]);
        }
    }

    /**
     * function to hide repin animation base on reel id,
     * in adjacet anticipation not paying we are stoppig the reelid+1 aimation also,
     * becoz we are create side bars animation only. to stop for each reel id we have to stop 2 bars.
     * @param reelId
     */
    public hideRespinAnticipation(reelId:number):void {
        this._reSpinAnimationContainer[reelId].visible = false;
        this._reSpinAnimationContainer[reelId].stopLoop();
        this._layer.removeChild(this._reSpinAnimationContainer[reelId]);
        if(!(this._respinAnticipationPlayingOnReels.indexOf(reelId + 1) !== -1)) {
            this._reSpinAnimationContainer[reelId + 1].visible = false;
            this._reSpinAnimationContainer[reelId + 1].stopLoop();
            this._layer.removeChild(this._reSpinAnimationContainer[reelId + 1]);
        }
    }

    /**
     * fuction to hide all respin animation
     * this function will be called when mode is respin and last no nudge reel will be stoppped.
     */
    public hideAllrespinAnimation():void {
        for(let index = 0; index < this._reSpinAnimationContainer.length; index++) {
            this._reSpinAnimationContainer[index].visible = false;
            this._reSpinAnimationContainer[index].stopLoop();
            this._layer.removeChild(this._reSpinAnimationContainer[index]);

        }
    }

    /**
     * function to play post tease animation base on nudgeUp/nudgeDown
     * set value for y, and angle
     * @param reelId
     * @param nudgeUp
     */
    public playPostTeaseAnimation(reelId:number, nudgeUp:boolean):void {
        let angleAnim:number = nudgeUp ? 0 : 180;
        let y:number = nudgeUp ? Helper.getSymbolPositions(reelId, 1)[1] + BarbarianFuryGameConfig.instance.SYMBOL_HEIGHT : Helper.getSymbolPositions(reelId, 1)[1];
        for(let j = 0; j < this._postteaseAnimationContainer[reelId].length; j++) {
            this._postteaseAnimationContainer[reelId][j].visible = true;
            this._postteaseAnimationContainer[reelId][j].getAnimationAutoShowHide(true, true);
            this._postteaseAnimationContainer[reelId][j].angle = angleAnim;
            this._postteaseAnimationContainer[reelId][j].y = y;
            this._layer.addChild(this._postteaseAnimationContainer[reelId][j]);
        }
    }

    /**
     * function to hide post teasing animation when nudge of particular reel get completed
     * @param reelId
     */
    public hideAllpostTeaseAnimation(reelId:number[]):void {
        for(let i = 0; i < reelId.length; i++) {
            for(let j = 0; j < this._postteaseAnimationContainer[reelId[i]].length; j++) {
                this._postteaseAnimationContainer[reelId[i]][j].visible = false;
                this._postteaseAnimationContainer[reelId[i]][j].stopLoop();
                this._layer.removeChild(this._postteaseAnimationContainer[reelId[i]][j]);
            }
        }

    }
}
